import React, { Fragment } from 'react';
import styled from 'styled-components';

import { swatches } from '../../styles/theme';
import Button from '../global/Button';
import CardContainer from '../global/CardContainer';
import CCContentWrapper from '../global/CardContainer/CCContentWrapper';
import CCImage from '../global/CardContainer/CCImage';
import H1 from '../global/typography/H1';
import NavLink from '../global/NavLink';
import P from '../global/typography/P';

const BreakpointMobile = '(max-width: 950px)';

const Polygon = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  background-color: ${p => p.theme.color.tertiary};
  clip-path: polygon(0 0, 100% 0%, 100% 70%, 0% 20%);
  width: 100%;
  height: 50%;
  margin-top: -1px;

  @media (max-width: 1200px) {
    height: 30%;
    clip-path: polygon(0 0, 100% 0%, 100% 50%, 0% 20%);
  }
`;

const StyledCardContainer = styled(CardContainer)`
  background-color: ${swatches.gray.dark};
  color: ${swatches.white};
  padding: 40px;

  @media ${BreakpointMobile} {
    flex-direction: column-reverse;
    gap: 20px;
  }
`;

const StyledButton = styled(Button)`
  height: 40px;
`;

const Content = styled(CCContentWrapper)`
  padding: 0px;
  padding-right: 33px;

  @media ${BreakpointMobile} {
    width: 100%;
  }
`;

const BigH1 = styled(H1)`
  color: ${swatches.white};
  font-size: 60px;
  margin-bottom: 0px;
`;

const Red = styled.span`
  color: ${swatches.primary};
`;

const StyledP = styled(P)`
  color: ${swatches.white};
`;

const AboutCard = () => (
  <Fragment>
    <Polygon />
    <StyledCardContainer flex>
      <Content>
        <BigH1>
          About <Red>Lochinvar</Red>
        </BigH1>
        <StyledP>
          For nearly 80 years, Lochinvar, an American company, has been a leader
          of innovation and high-efficiency water heating. Through Lochinvar's
          pride in leadership and commitment to excellence, the company has
          continually improved year after year.
        </StyledP>
        <StyledP>
          Today, Lochinvar touts the broadest line of high-efficiency water
          heating solutions, a world-class research & development department,
          comprehensive service with every sale and industry-leading training
          through Lochinvar University.
        </StyledP>
        <NavLink to="/about">
          <StyledButton>See how we do it</StyledButton>
        </NavLink>
      </Content>
      <CCImage
        image={{
          src: '/home/LocationImage.jpg',
          alt: 'Lochinvar Building'
        }}
        order={2}
        width="100%"
      />
    </StyledCardContainer>
  </Fragment>
);

export default AboutCard;
